import config from './config'

import emitter from './emitter'

import Mediator from './globals/mediator'

export default class App {

    constructor(options) {

        config.touchDevice = options.touchDevice != null ? options.touchDevice : false

        config.container = options.container != null ? options.container : null
    }

    start(){

        let w3 = require('./world3D.js')

        this.world3D = new w3.default();

        Mediator.addEvents()
    }

    resize(){

        Mediator.resize()
    }


    update(){

        Mediator.update()
    }

    triggerLight(a, b){

        emitter.emit('triggerLight',a, b)
    }

    // colorA

    set colorA(val){

        this._colorA = val

        emitter.emit('colorA', val)
    }

    get colorA(){

        return this._colorA
    }

    // colorB

    set colorB(val){

        this._colorB = val

        emitter.emit('colorB', val)
    }

    get colorB(){

        return this._colorB
    }

    // lightcolorA

    set lightcolorA(val){

        this._lightcolorA = val

        emitter.emit('lightcolorA', val)
    }

    get lightcolorA(){

        return this._lightcolorA
    }

    // lightcolorB

    set lightcolorB(val){

        this._lightcolorB = val

        emitter.emit('lightcolorB', val)
    }

    get lightcolorB(){

        return this._lightcolorA
    }

    // scaleY

    set scaleY(val){

        this._scaleY = val

        emitter.emit('scaleY', val)
    }

    get scaleY(){

        return this._scaleY
    }

    // frequency

    set frequency(val){

        this._frequency = val

        emitter.emit('frequency', val)
    }

    get frequency(){

        return this._frequency
    }

    // frequency

    set frequency2(val){

        this._frequency2 = val

        emitter.emit('frequency2', val)
    }

    get frequency2(){

        return this._frequency2
    }

    // amplitude

    set amplitude(val){

        this._amplitude = val

        emitter.emit('amplitude', val)
    }

    get amplitude(){

        return this._amplitude
    }

    // amplitude2

    set amplitude2(val){

        this._amplitude2 = val

        emitter.emit('amplitude2', val)
    }

    get amplitude2(){

        return this._amplitude2
    }

    // lightLength

    set lightLength(val){

        this._lightLength = val

        emitter.emit('lightLength', val)
    }

    get lightLength(){

        return this._lightLength
    }

    // lightSpeed

    set lightSpeed(val){

        this._lightSpeed = val

        emitter.emit('lightSpeed', val)
    }

    get lightSpeed(){

        return this._lightSpeed
    }

    // globalSpeed

    set globalSpeed(val){

        this._globalSpeed = val

        emitter.emit('globalSpeed', val)
    }

    get globalSpeed(){

        return this._globalSpeed
    }


    // bloomStrength

    set bloomStrength(val){

        this._bloomStrength = val

        emitter.emit('bloomStrength', val)
    }

    get bloomStrength(){

        return this._bloomStrength
    }

    // bloomRadius

    set bloomRadius(val){

        this._bloomRadius = val

        emitter.emit('bloomRadius', val)
    }

    get bloomRadius(){

        return this._bloomRadius
    }

    set bounceAmplitude(val){

        this._bounceAmplitude = val

        emitter.emit('bounceAmplitude', val)
    }

    get bounceAmplitude(){

        return this._bounceAmplitude
    }

    set bounceRange(val){

        this._bounceRange = val

        emitter.emit('bounceRange', val)
    }

    get bounceRange(){

        return this._bounceRange
    }


}


// WEBPACK FOOTER //
// ./src/scripts/Trail/App.js